const DOCUMENT_RELATIVE_INDEX_PATH = 'document-processor';
const COMMERCIAL_INVOICE_RELATIVE_INDEX_PATH = 'commercial-invoice';
const HOUSE_BILL_OF_LADING_RELATIVE_INDEX_PATH = 'house-bill-of-lading';
const RESULTS_RELATIVE_INDEX_PATH = 'results';

export const DOCUMENT_ROUTE_PREFIX = `/dashboard/${DOCUMENT_RELATIVE_INDEX_PATH}`;

interface DocumentProcessorRoutes {
  commercialInvoice: {
    getUrl: (id: string) => string;
    path: string;
    relativePath: string;
  };
  houseBillOfLading: {
    getUrl: (id: string) => string;
    path: string;
    relativePath: string;
  };
  index: {
    getUrl: () => string;
    path: string;
    relativePath: string;
  };
  parseResult: {
    getUrl: (documentId: string, documentType: string) => string;
    path: string;
    relativePath: string;
  };
}

const documentProcessorRoutes: DocumentProcessorRoutes = {
  index: {
    getUrl: () => DOCUMENT_ROUTE_PREFIX,
    path: DOCUMENT_ROUTE_PREFIX,
    relativePath: `${DOCUMENT_RELATIVE_INDEX_PATH}/*`
  },
  commercialInvoice: {
    getUrl: (documentId: string) => `${DOCUMENT_ROUTE_PREFIX}/${COMMERCIAL_INVOICE_RELATIVE_INDEX_PATH}/${documentId}`,
    path: `${DOCUMENT_ROUTE_PREFIX}/${COMMERCIAL_INVOICE_RELATIVE_INDEX_PATH}/:id/:parserType`,
    relativePath: `${COMMERCIAL_INVOICE_RELATIVE_INDEX_PATH}/:id`
  },
  houseBillOfLading: {
    getUrl: (documentId: string) => `${DOCUMENT_ROUTE_PREFIX}/${HOUSE_BILL_OF_LADING_RELATIVE_INDEX_PATH}/${documentId}`,
    path: `${DOCUMENT_ROUTE_PREFIX}/${HOUSE_BILL_OF_LADING_RELATIVE_INDEX_PATH}/:id/:parserType`,
    relativePath: `${HOUSE_BILL_OF_LADING_RELATIVE_INDEX_PATH}/:id`
  },
  parseResult: {
    getUrl: (documentId: string, documentType: string) =>
      `${DOCUMENT_ROUTE_PREFIX}/${RESULTS_RELATIVE_INDEX_PATH}/${documentId}/${documentType}`,
    path: `${DOCUMENT_ROUTE_PREFIX}/${RESULTS_RELATIVE_INDEX_PATH}/:id/:documentType`,
    relativePath: `${RESULTS_RELATIVE_INDEX_PATH}/:id/:documentType`
  }
};

export default documentProcessorRoutes;
